import type { ComponentProps } from 'react';
import { Card } from '../card';
import { Tabs } from '../tabs';

type P = {
  card?: ComponentProps<typeof Card>;
  tabs?: ComponentProps<typeof Tabs>;
};

const CardTabs = ({ card, tabs }: P) => (
  <Card className="card-tabs" {...card}>
    <Tabs
      className="card-tabs__tabs"
      classNames={{ content: 'card-tabs__content' }}
      size="large"
      tabPosition="left"
      type="card"
      {...tabs}
    />
  </Card>
);

export default CardTabs;
